import stage from './stage.json';
import api from './api.json';
import hostnames from './hostnames.json';
import developerids from './developerids.json';

const defaultSettings = {
  // CRA uses webpack which ignores env vars without "REACT_APP" prefix
  REACT_APP_HOST_URL:
  process.env.REACT_APP_STAGE === 'docker'
    ? 'http://localhost:3000'
    : `https://${hostnames[stage]}`,
  REACT_APP_API_URL:
    process.env.REACT_APP_STAGE === 'docker'
      ? 'http://localhost:3000'
      : `https://${api[stage]}`,
  REACT_APP_DEVELOPER_ID:
      process.env.REACT_APP_STAGE === 'docker'
        ? 'b1111111'
        : developerids[stage],
};

// prettier-ignore
// eslint-disable-next-line import/no-anonymous-default-export
export default { ...defaultSettings };
